import { h } from 'preact';
import FilePreview from "../../FilePreview.js";
import MetaErrorMessage from "../MetaErrorMessage.js";
import getFileTypeIcon from "../../../utils/getFileTypeIcon.js";
export default function FilePreviewAndLink(props) {
  var file = props.file,
    i18n = props.i18n,
    toggleFileCard = props.toggleFileCard,
    metaFields = props.metaFields,
    showLinkToFileUploadResult = props.showLinkToFileUploadResult;
  var white = 'rgba(255, 255, 255, 0.5)';
  var previewBackgroundColor = file.preview ? white : getFileTypeIcon(file.type).color;
  return h("div", {
    className: "uppy-Dashboard-Item-previewInnerWrap",
    style: {
      backgroundColor: previewBackgroundColor
    }
  }, showLinkToFileUploadResult && file.uploadURL && h("a", {
    className: "uppy-Dashboard-Item-previewLink",
    href: file.uploadURL,
    rel: "noreferrer noopener",
    target: "_blank",
    "aria-label": file.meta.name
  }, h("span", {
    hidden: true
  }, file.meta.name)), h(FilePreview, {
    file: file
  }), h(MetaErrorMessage, {
    file: file,
    i18n: i18n,
    toggleFileCard: toggleFileCard,
    metaFields: metaFields
  }));
}